import { useEffect } from "react";
import { OptionTemplate } from "shared/api/middleware-api-client";

interface UseUrlSelectionSyncParams {
  colorOptions?: OptionTemplate[];
  currentColorCode?: string;
  currentGlassCode?: string;
  currentHandleCode?: string;
  currentLayoutCode?: string;
  doorCode?: string;
  extraOptions?: OptionTemplate[];
  glassOptions?: OptionTemplate[];
  handleOptions?: OptionTemplate[];
  initializeExtraOptionsFromUrl: () => void;
  layoutOptions?: OptionTemplate[];
  searchedColor: string;
  searchedExtra: string;
  searchedGlass: string;
  searchedHandle: string;
  searchedLayout: string;
  setColor: () => void;
  setGlass: () => void;
  setHandle: () => void;
  setLayout: () => void;
}

export const useUrlSelectionSync = ({
  colorOptions,
  currentColorCode,
  currentGlassCode,
  currentHandleCode,
  currentLayoutCode,
  doorCode,
  extraOptions,
  glassOptions,
  handleOptions,
  initializeExtraOptionsFromUrl,
  layoutOptions,
  searchedColor,
  searchedExtra,
  searchedGlass,
  searchedHandle,
  searchedLayout,
  setColor,
  setGlass,
  setHandle,
  setLayout,
}: UseUrlSelectionSyncParams) => {
  useEffect(() => {
    if (!doorCode || !layoutOptions || searchedLayout === currentLayoutCode) {
      return;
    }

    setLayout();
  }, [doorCode, layoutOptions, searchedLayout, currentLayoutCode, setLayout]);

  useEffect(() => {
    if (!doorCode || !colorOptions || searchedColor === currentColorCode) {
      return;
    }

    setColor();
  }, [doorCode, colorOptions, searchedColor, currentColorCode, setColor]);

  useEffect(() => {
    if (!doorCode || !glassOptions || searchedGlass === currentGlassCode) {
      return;
    }

    setGlass();
  }, [doorCode, glassOptions, searchedGlass, currentGlassCode, setGlass]);

  useEffect(() => {
    if (!doorCode || !handleOptions || searchedHandle === currentHandleCode) {
      return;
    }

    setHandle();
  }, [doorCode, handleOptions, searchedHandle, currentHandleCode, setHandle]);

  useEffect(() => {
    if (!doorCode || !extraOptions) {
      return;
    }

    initializeExtraOptionsFromUrl();
  }, [doorCode, extraOptions, initializeExtraOptionsFromUrl, searchedExtra]);
};
